// extracted by mini-css-extract-plugin
export default {"container":"styles_container__vdzos","paragraph":"styles_paragraph__p4IAg"};